// public-site/src/api.js
// Thin client for the public funeral payment endpoints. Points at the existing
// backend service via REACT_APP_BACKEND_URL (build-time). Uses a customer token
// stored under a key separate from the staff app.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const TOKEN_KEY = 'funeralCustomerToken';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

async function request(path, { method = 'GET', body, auth = false } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth) {
    const token = getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;
  }

  let res;
  try {
    res = await fetch(`${BACKEND_URL}${path}`, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch (networkErr) {
    throw new Error('We could not reach the payment system. Please check your connection and try again.');
  }

  let data = {};
  try {
    data = await res.json();
  } catch (e) {
    /* non-JSON response */
  }

  if (!res.ok) {
    const err = new Error(data.error || 'Something went wrong. Please try again.');
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export function login({ caseNumber, decedentLastName, responsiblePartyLastName }) {
  return request('/api/public/funeral/login', {
    method: 'POST',
    body: { caseNumber, decedentLastName, responsiblePartyLastName },
  });
}

export function getCase() {
  return request('/api/public/funeral/case', { auth: true });
}

export function pay(payload) {
  return request('/api/public/funeral/pay', { method: 'POST', auth: true, body: payload });
}

export function removeCard() {
  return request('/api/public/funeral/remove-card', { method: 'POST', auth: true });
}

export function formatUSD(amount) {
  const n = Number(amount) || 0;
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}
